import { ReactComponent as AccountIcon } from "./assets/icons/accountIcon.svg";
import { ReactComponent as ReferAClientIcon } from "./assets/icons/referAClientIcon.svg";
import { ReactComponent as ClientManagementIcon } from "./assets/icons/clientManagementIcon.svg";
import { ReactComponent as ResourcesIcon } from "./assets/icons/resourcesIcon.svg";
import { ReactComponent as CommissionsIcon } from "./assets/icons/commissionsIcon.svg";
import { ReactComponent as InvoicesIcon } from "./assets/icons/invoicesIcon.svg";
import { ReactComponent as SettingsIcon } from "./assets/icons/settingsIcon.svg";
import { ReactComponent as ReferralsIcon } from './assets/icons/referralsIcon.svg';
import { GoogleAnalytics4Tags } from "../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags";

export type MenuItem = {
  label: string;
  route: string;
  icon: JSX.Element;
  type: string;
  gaTag: string;
}

export const MENU_ITEMS: MenuItem[] = [
  { label: "sidebar.account.label", route: "/account", icon: <AccountIcon />, type: "account", gaTag: GoogleAnalytics4Tags.menuClicks.click.account },
  { label: "sidebar.refer.label", route: "/refer", icon: <ReferAClientIcon />, type: "referAClient", gaTag: GoogleAnalytics4Tags.menuClicks.click.makeAReferral },
  { label: "sidebar.clientManagement.label", route: "/client_management", icon: <ClientManagementIcon />, type: "clientManagement", gaTag: GoogleAnalytics4Tags.menuClicks.click.clientManagement },
  { label: "sidebar.resources.label", route: "/resources", icon: <ResourcesIcon />, type: "resources", gaTag: GoogleAnalytics4Tags.menuClicks.click.resources },
  { label: "sidebar.referrals.label", route: "/referrals", icon: <ReferralsIcon />, type: "referrals", gaTag: GoogleAnalytics4Tags.menuClicks.click.referralActivity },
  { label: "sidebar.commissions.label", route: "/commissions", icon: <CommissionsIcon />, type: "commissions", gaTag: GoogleAnalytics4Tags.menuClicks.click.commissions },
  { label: "sidebar.invoices.label", route: "/invoices", icon: <InvoicesIcon />, type: "invoices", gaTag: GoogleAnalytics4Tags.menuClicks.click.invoices },
  { label: "sidebar.settings.label", route: "/settings", icon: <SettingsIcon />, type: "settings", gaTag: GoogleAnalytics4Tags.menuClicks.click.settings },
];
